module.exports = __webpack_public_path__ + "static/media/craft_brew_event.0c5d6f87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightsHome/img/craft_brew_event.jpg
// module id = 258
// module chunks = 0